/** @jsx jsx */
import { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Box, Link as ExternalLink, jsx } from "theme-ui"

function PressMarquee() {
  const data = useStaticQuery(graphql`
    query PressMarqueeQuery {
      sanityPressMarquee(_id: { eq: "pressMarquee" }) {
        items {
          _key
          url
          title
          image {
            asset {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  const [paused, setPaused] = useState(false)

  const styles = {
    container: {
      position: "relative",
      display: "inline-flex",
      overflow: "hidden",
      color: "darkGreen",
      fontFamily: "body",
      height: ["95px", "95px", "130px", "160px"],
      width: "100%",
      alignItems: "center",
    },
    ticker: {
      minWidth: "unset",
      display: "flex",
      alignItems: "center",
      whiteSpace: "nowrap",
      animation: "ticker 30s linear infinite",
      animationPlayState: paused ? "paused" : "running",
      "&:hover > *:not(:hover)": {
        opacity: 0.4,
      },
    },
    tickerItem: {
      minWidth: "unset",
      display: "inline-flex",
      padding: ["0 42px", "0 42px", "0 52px"],
      transition: "all 250ms linear",
      "&:hover > *:hover": {
        transform: "scale(1.05)",
      },
      img: {
        objectFit: "contain",
        maxWidth: ["160px", "160px", "200px", "290px"],
        maxHeight: ["24px", "24px", "28px", "32px"],
      },
    },
  }

  const images = data.sanityPressMarquee.items.map(item => item)

  return (
    <Box as="section" backgroundColor={"lightGreen"} sx={styles.container}>
      <Box as="div" sx={styles.ticker}>
        {[...images, ...images].map((image, idx) => (
          <ExternalLink
            key={idx}
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            href={image.url}
            title={`Marco on ${image.title}`}
            target="_blank"
            rel="noopener"
            sx={styles.tickerItem}
          >
            <img
              src={image.image.asset.localFile.publicURL}
              alt={image.title}
            />
          </ExternalLink>
        ))}
      </Box>
    </Box>
  )
}

export default PressMarquee
